export const enum Errors {
  SAMSUNG_TOKEN_EXPIRED = "samsung_token_expired",
  SESSION_EXPIRED = "session_expired",
  GENERIC_ERROR = "generic_error",
}
